import * as React from "react";
import Loader from "../Loader/Loader";
import styles from "./BusyLoading.scss";

const BusyLoading: React.FunctionComponent = () => (
    <div className={styles.busyLoading}>
        <Loader />
    </div>
);

export default BusyLoading;


// WEBPACK FOOTER //
// ./src/Components/Loading/BusyLoading/BusyLoading.tsx